import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function (theme) {
  return {
    title: {
      lineHeight: 1,
      padding: 0,
      margin: 0,
      fontWeight: 400,
      fontSize: theme.fontSizes.md
    }
  };
});
export default useStyles;